import {getPerformances} from './../services/firebaseServices';

export const SET_PERFORMANCES = 'SET_PERFORMANCES';

const setPerformances = (data) => {
  return { type: SET_PERFORMANCES, data };
};

export const fetchPerformances = () => {
  return (dispatch) => {
    getPerformances()
      .then((data)=> {
      dispatch(setPerformances(data))
    })
      .catch(dispatch(setPerformances([])));
  }
};



/** WEBPACK FOOTER **
 ** ./src/actions/performances.actions.js
 **/